// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"c921c63b","146":"af30a0fa","150":"4511fd90","153":"edeba431","196":"9891d2b3","350":"e6aad68d","365":"b1784629","439":"c75416c7","448":"5b70fc5a","449":"380185bc","830":"f3c54ab7","840":"d3351b79","957":"2df05e2c","977":"71295cad","979":"2045db4c"}[chunkId] + ".chunk.js";
};